import { Attrs, MinzeElement } from 'minze'

export interface LvcPointyPopupArrow {
  dataWidth: number
  dataHeight: number
}

export class LvcPointyPopupArrow extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 19],
    ['data-height', 11],
  ]
  html = () => `

        <svg class="border-arrow" width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.09247 10.5L9.5 0.76497L17.9075 10.5H1.09247Z" fill="white" stroke="#BCB3D8"/>
    </svg>

    <svg class="white-arrow" width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 0L19 11H0L9.5 0Z" fill="white"/>
    </svg>
  
  `

  css = () => `

    :host{
        position:relative;
        display:block;
        width: ${this.dataWidth}px;
        height: ${this.dataHeight}px;
        
    }

    .border-arrow {
        position: absolute;
        top: -1px;
        left: 0;
        display:block;
    }

    .white-arrow {
        position: absolute;
        top: 0;
        left: 0;
        display:block;
    }
    
  `
}
